import { render, staticRenderFns } from "./clueOneBuyCar.vue?vue&type=template&id=1471f774"
import script from "./clueOneBuyCar.vue?vue&type=script&lang=js"
export * from "./clueOneBuyCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports